import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { concatMap, Observable } from 'rxjs';
import { Richiesta } from '../../../types/Richiesta';
import { DettaglioRichiestaService } from '../dettaglio-richiesta.service';
import { Stato, ulterioreDato } from '../../../types/Stato';
import { CruscottoRichiestaService } from '../../cruscotto-richiesta.service';
import { Mirko3Component } from "../../../mirko3/mirko3.component";
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SceltaPdeComponent } from '../../../scelta-pde/scelta-pde.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule, provideNativeDateAdapter } from '@angular/material/core';
import { SicotService } from '../../../sicot.service';
import { StatoRichResponse } from '../../../types/StatoRichResponse';
import { SceltaPdeStrutturaComponent } from "../../../scelta-pde-struttura/scelta-pde-struttura.component";

@Component({
  selector: 'app-gestione-richiesta',
  imports: [MatCardModule, MatButtonModule, MatIconModule, NgIf, NgForOf, Mirko3Component, MatFormFieldModule, MatInputModule, FormsModule, SceltaPdeComponent, MatDatepickerModule, MatFormFieldModule, FormsModule, MatInputModule, MatNativeDateModule, ReactiveFormsModule, SceltaPdeStrutturaComponent],
  templateUrl: './gestione-richiesta.component.html',
  styleUrl: './gestione-richiesta.component.css',
  providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }]
})
export class GestioneRichiestaComponent {
  showPDE = false;
  textInput: string = '';

  dataAccesso: FormControl = new FormControl('');

  noteAggiuntive: FormControl = new FormControl('');

  @Output() valueChanged = new EventEmitter<boolean>();


  constructor(private dettaglioRichiestaService: DettaglioRichiestaService, private cruscottoRcihiestaService: CruscottoRichiestaService, private siCotService: SicotService) { }

  statoRichRepsponse: StatoRichResponse | undefined;
  stato: string | undefined;
  ulterioreDato: any;
  @Input() idRichiesta: any;

  ngOnInit() {
    this.postStatoRichiesta();
    this.getInterventoPaziente();
  }


  postStatoRichiesta() {
    this.dettaglioRichiestaService.postStatoRichiesta(this.idRichiesta)
      .subscribe({
        next: (response: StatoRichResponse) => {
          this.statoRichRepsponse = response;
          console.log(this.statoRichRepsponse);
          this.stato = response.stato;
          this.ulterioreDato = (response.ulterioriDati)?.find((d) => d.label === "uvm")?.value;
          console.log('Operazioni completate con successo:', response);
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

  nextStep(): void {
    console.log(this.dataAccesso.value);
    this.dettaglioRichiestaService.updateStatoRichiesta(this.idRichiesta)
      .subscribe({
        next: (response: any) => {
          this.stato = response.stato;
          console.log('Operazioni completate con successo:', response);
          this.postStatoRichiesta();
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

  nextStepNo(): void {
    console.log(this.dataAccesso.value);
    this.dettaglioRichiestaService.updateStatoRichiestaNo(this.idRichiesta)
      .subscribe({
        next: (response: any) => {
          this.stato = response.stato;
          console.log('Operazioni completate con successo:', response);
          this.postStatoRichiesta();
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

  nextStepDataAccesso(): void {
    console.log(this.dataAccesso.value);
    if (this.dataAccesso.value) {
      this.dettaglioRichiestaService.updateStatoRichiestaConDataAccesso(this.idRichiesta, this.dataAccesso.value, this.noteAggiuntive.value)
        .subscribe({
          next: (response: any) => {
            this.stato = response.stato;
            console.log('Operazioni completate con successo:', response);
            this.postStatoRichiesta();
          },
          error: (error: any) => {
            console.error('Errore durante l\'esecuzione delle operazioni:', error);
          }
        });
    }
  }

  refreshState(newValue: boolean) {
    this.postStatoRichiesta();
    this.idRichiesta = this.idRichiesta;
    this.getInterventoPaziente();
    this.valueChanged.emit(true);
  }




  sendJsonNotificaCambioSetting(): void {
    const requestBody: any = this.textInput;
    this.dettaglioRichiestaService.setNotificaCambioSetting(requestBody).subscribe(
      (data) => {
        console.log(data);
        this.refreshState(true);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  getInterventoPaziente() {
    this.siCotService.getInterventiPazienteByRichiesta(this.idRichiesta)
      .subscribe({
        next: (response: any[]) => {
          this.showPDE = response.length > 0;
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

  provaMirko(e:any){
    console.log("Gestione richiesta")
    console.log(e);
  }

}
